/**
 * @fileoverview Agent definition for world-set-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world set's details.
 * The user selects one direction before full details are generated.
 *
 * @category world-building.sets.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-set-details-ideation-v3',
  kind: 'primitive',
  name: 'World Set Details Ideation',
  description: 'Generates creative directions for developing a world set before full detail generation.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.sets.details',
    usedBy: ['use-world-set-details-ideation-v3.ts'],
    usedInComposites: [],
    relatedAgents: ['world-set-details-generator-v3'],
  },
};
